import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from "./locale/en.json";
import frTranslations from "./locale/fr.json";

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: {
            en: {
                translation: enTranslations
            },
            fr: {
                translation: frTranslations
            }
        },
        lng: "fr",
        fallbackLng: "fr",

        interpolation: {
            escapeValue: false
        }
    });
export default i18n;